import { fetchProvinces, fetchBackCates } from '@/services/api';
import { fetchNewBackCates } from '@/services/basic';
import { fetchAllLocation } from '@/services/geographic';
import { formatCateData } from '@/utils/logicUtils';
import {
  DEFAULT_ID,
  defaultProvinceList,
  defaultCityList,
  defaultDistrictList,
} from '../configs/basicInfo';

export default {
  namespace: 'basic',

  state: {
    configs: {}, // portm常量配置
    allLocationInfo: {
      provinceList: defaultProvinceList,
      cityList: defaultCityList,
      districtList: defaultDistrictList,
    }, // 全国全部的的省市区等信息
    provinces: [],
    cities: [],
    districts: [],
    backCates: {}, // 后台类目信息
    allLocationList: [], // 包含/城市/行政区所有数据
    newBackCates: {}, // 新的后台类目接口，跟老的接口返回的数据结构不一致没办法替换,很多页面使用类目backCates，等所有的后台类目使用最新的记得删除老的
  },

  effects: {
    *fetchProvinces(_, { call, put }) {
      const response = yield call(fetchProvinces);
      yield put({
        type: 'setProvinces',
        payload: Array.isArray(response) ? response : [],
      });
    },
    *fetchBackCates({ payload }, { call, put }) {
      const response = yield call(fetchBackCates, payload);
      yield put({
        type: 'setBackCates',
        payload: response || {},
      });
    },
    *fetchNewBackCates({ payload }, { call, put }) {
      let response = yield call(fetchNewBackCates, payload);
      if (response && response.categoryTree) {
        response.categoryTree = formatCateData(response.categoryTree || []);
        yield put({
          type: 'setField',
          payload: {
            newBackCates: response || {},
          },
        });
      }
    },
    *fetchAllLocationList({ payload }, { call, put }) {
      let response = yield call(fetchAllLocation, payload);
      if (response && Array.isArray(response)) {
        yield put({
          type: 'setField',
          payload: {
            allLocationList: response,
          },
        });
      }
    },
  },

  reducers: {
    setConfigs(state, action) {
      return {
        ...state,
        configs: action.payload,
      };
    },
    setAllLocationInfo(state, action) {
      const { allLocationInfo } = state;
      const { payload } = action;
      return {
        ...state,
        allLocationInfo: {
          ...allLocationInfo,
          ...payload,
        },
      };
    },
    setProvinces(state, action) {
      return {
        ...state,
        provinces: action.payload,
      };
    },
    setBackCates(state, action) {
      return {
        ...state,
        backCates: action.payload,
      };
    },
    setField(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
